const cardGradients = [
    `radial-gradient(
      circle closest-corner,
      rgba(255, 255, 255, 0.17),
      rgba(122, 139, 150, 0.13)
    )`,
];
const cardGradientPositions = [
    'center',
    'center',
    'center',
    'center',
    'center',
];
const cardGradientSizes = [
    'contain',
    'contain',
    'contain',
    'contain',
    'contain',
];
export { cardGradients, cardGradientPositions, cardGradientSizes };
export default { cardGradients, cardGradientPositions, cardGradientSizes };
